<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9vQRI9/images/cover.jpg?1684306039989" alt="This image is the cover for the book Hoops in Connecticut, Sports"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hoops in Connecticut, Sports
      </h1>
      <p class="bookDescription body article font2">
        <p>Home to both the University of Connecticut�s men�s and women�s NCAA championship teams as well as the Connecticut Sun WNBA team, this small state has made a name for itself in basketball. Infatuation with the sport started here in 1896 with the first intercollegiate game between Yale and Wesleyan Universities. The roster of Connecticut�s round ball greats includes Naismith Hall-of-Famer Calvin Murphy; NBA stars Vin Baker, Marcus Camby, Charles Smith, the late John Williamson, Johnny Egan and John Bagley; and Harlem Globetrotter Alvin Clinkscales. Award-winning sportswriter Don Harrison wows fans with stories of the Nutmeg State�s most notable players and coaches through personal interviews and firsthand accounts.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Don Harrison
      </h2>
      
      <p class="authorDescription body article">Don Harrison has covered basketball for the Waterbury Republican, Waterbury American and New Haven Journal-Courier. During his tenure in Waterbury, he won two �Connecticut Sportswriter of the Year� awards from the National Sportscasters and Sportswriters Association. His cover story for the Fairfield County Advocate, �The Devil Drives,� was cited in The Best American Sportswriting 1993. Away from the sports arena, Don was the founding editor of the Greenwich Citizen, a weekly newspaper that garnered several awards� including one for General Excellence�from the New England Press Association and the Connecticut Press Club. He is a contributing columnist to two news websites, Fairfield Patch and Naugatuck Patch. Don and his wife, Patti, reside in Fairfield, Connecticut.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1ae51358